'use client';

import { useMemo } from 'react';
import { useSearchParams } from 'next/navigation';
import useLocation from 'hooks/useLocation';

import { SearchListStyle, SearchGridColumns } from 'components/SearchList/SearchList.css';
import PlaceCard from 'components/Shared/PlaceCard/PlaceCard';
import { createPropsToTrackingMatrix } from 'components/Integration/createPropsToTrackingMatrix';
import { filterParams } from 'components/SearchFilter/filterOptions';
import { ParamsResult } from 'ParamsResult';
import { SearchPlaces } from 'searchPlaces.d';

function SearchPlacesList({ places, serviceParams }: { places: SearchPlaces[]; serviceParams: ParamsResult }) {
  const locationStore = useLocation();
  const searchParams = useSearchParams();

  const filters = useMemo(() => {
    const state = Object.entries(filterParams).map(([key, content]) => {
      const queryParam = searchParams?.get(content.name) as string | undefined;

      if (!queryParam) return [key, false];
      return [key, queryParam];
    });

    return Object.fromEntries(state);
  }, [searchParams]);

  return (
    <div className={`${SearchListStyle} ${SearchGridColumns.placesList}`}>
      {places?.map((place, idx) => (
        <PlaceCard
          key={place.id}
          hasPriority={!idx}
          {...place}
          {...createPropsToTrackingMatrix(idx, {
            type: 'venue',
            trackingPrefix: 'search',
            matrizTemplate: '',
            componentTemplate: '',
            dataLocation: locationStore.selectedLocation,
            cardType: 'event-card-search',
            serviceParams,
            payloadCard: place,
            filters,
          })}
        />
      ))}
    </div>
  );
}

export default SearchPlacesList;
